import { useTranslation } from 'react-i18next';

/**
 * WHATSAPP FILE CHIP — chip del file allegato (nome troncato + pulsante di
 * rimozione ×), condiviso fra il composer inline e il modale WhatsApp. Un solo
 * markup e una sola classe (`.wa-file-chip`) per entrambi i punti.
 */
interface WhatsAppFileChipProps {
  fileName: string;
  onRemove: () => void;
}

export function WhatsAppFileChip({ fileName, onRemove }: WhatsAppFileChipProps) {
  const { t } = useTranslation();

  return (
    <span className="wa-file-chip">
      <span className="wa-file-chip__name">{fileName}</span>
      <button
        type="button"
        className="wa-file-chip__remove"
        aria-label={t('whatsapp.media.remove')}
        onClick={onRemove}
      >
        ×
      </button>
    </span>
  );
}

export default WhatsAppFileChip;
